export default {"src":"/_next/static/media/jet_skiing.8b9c6320.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};